export default {
  defaultPostText: "Read on Rivals",
  share: "Share:"
};
